module.exports = __webpack_public_path__ + "img/diamondjewelry@2x.cee4fcf.jpg";